import {
  TabbedShowLayout as RaTabbedShowLayout,
  TabbedShowLayoutProps as RaTabbedShowLayoutProps,
} from 'react-admin';

export type TabbedShowLayoutProps = RaTabbedShowLayoutProps;

export const TabbedShowLayout = RaTabbedShowLayout;
